const ffToColorPicker = (field) => ({
    ...field.state,
    hasError: field.error,
    domRef: field.domRef,
});
exports.ffToColorPicker = ffToColorPicker;
